import InvestorFullNameMediaContainer from './InvestorFullNameMediaContainer';

export default InvestorFullNameMediaContainer;
